import React, { useEffect } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import CateringFormContent from './CateringFormContent';

const CateringFormView = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <section className="theme-light section m-0 p-0" data-theme="light">
      <div className='is-flex is-flex-direction-column is-justify-content-start'>
        <Navigation 
          colorMode="colorWhite"
        />
        
        {/* Hero Section with Background Image */}
        <CateringFormContent 
            className="content-space-160 is-12-mobile is-12-tablet is-8-desktop is-6-widescreen is-6-fullhd is-offset-0-mobile is-offset-0-tablet is-offset-2-desktop is-offset-3-widescreen is-offset-3-fullhd"
            title="Catering Request Quote"
            subtitle="Submit your Catering Request Quote, and a member of the Kinder's team will get in touch within 24 hours to iron out all the delicious details."
            colorMode="colorBlack"
        />

        <Footer />
      </div>
    </section>
  );
};

export default CateringFormView;